import React, { useState, useEffect } from "react";
import { toast } from 'react-toastify';
import CssCodeEditor from "../../CssCodeEditor"; 
import JsCodeEditor from "../../JsCodeEditor";

const GeneralTab = ({ updateChatTabData, chatTabData }) => {
    const [activeSettingElementsTab, setActiveSettingElementsTab] = useState("main");
    const [chatWindowImage, setChatWindowImage] = useState(chatTabData.chat_window_picture);
    const [chatWindowName, setChatWindowName] = useState(chatTabData.chat_window_name);
    const [isEnableChatHistoryToEmail, setIsEnableChatHistoryToEmail] = useState(Number(chatTabData.is_send_chat_history_to_email));
    const [ownerEmail, setOwnerEmail] = useState(chatTabData.owner_email);
    const [styleTabCustomCss, setStyleTabCustomCss] = useState(chatTabData.custom_css);
    const [jsTabCustomJs, setJsTabCustomJs] = useState(chatTabData.custom_js);

    // Handlers Bubble Text Change
    const handleChatWindowImageChange = (event) => {
        const file = event.target.files[0];
        if (file) {
            setChatWindowImage(URL.createObjectURL(file));
            updateChatTabData("chat_window_picture", file);
        }
    }

    // Handlers Chat Window Name Change
    const handleChatWindowNameChange = (event) => {
        const value = event.target.value;
        setChatWindowName(value);
        updateChatTabData("chat_window_name", value);
    };
    
    //Handle Enable Chat History To Email Change
    const handleEnableChatHistoryToEmailChange = (e) => {
        const checked = e.target.checked;
        setIsEnableChatHistoryToEmail(checked);
        updateChatTabData("is_send_chat_history_to_email", checked); 
    };

    // Handlers Owner Email Change
    const handleOwnerEmailChange = (event) => {
        const value = event.target.value;
        setOwnerEmail(value);
        updateChatTabData("owner_email", value);
    };

    // Handlers Custom CSS Change
    const handleCustomcssCodeChange = (code) => {
        setStyleTabCustomCss(code);
        updateChatTabData("custom_css", code);
    };

    //Inject CSS into the page whenever it changes
    useEffect(() => {
        let styleTag = document.getElementById("custom-style");

        if (!styleTag) {
            styleTag = document.createElement("style");
            styleTag.id = "custom-style";
            document.head.appendChild(styleTag);
        }

        styleTag.innerHTML = styleTabCustomCss || "";
    }, [styleTabCustomCss]);

    // Handlers Custom Js Change
    const handleCustomJsCodeChange = (code) => {
        setJsTabCustomJs(code);
        updateChatTabData("custom_js", code);
    };

    // Function to run the JS code when Validate is clicked
    const handleValidateClick = () => {
        const existingScript = document.getElementById("custom-js");
        if (existingScript) {
            existingScript.remove();
        }
    
        if (jsTabCustomJs && jsTabCustomJs.trim() !== "") {
            const script = document.createElement("script");
            script.id = "custom-js";
            script.type = "text/javascript";
            script.innerHTML = jsTabCustomJs;
    
            document.body.appendChild(script);
    
            toast.success("Custom JS applied successfully");
        } else {
            toast.error("No JS code to apply");
        }
    };

    return (
        <div className="side-baar-inner-setting">
            {activeSettingElementsTab === "main" && (
                <>
                    <span>General Settings</span>
                    <div className="side-baar-box-header">
                        <div className="box-header-row bubble-text">
                            <label>Name</label>
                            <input type="text" value={chatWindowName} onChange={handleChatWindowNameChange} placeholder="John Doe" />
                        </div>
                        <div className="box-header-row">
                            <span>Profile Picture</span>
                            <em>
                                <button className="button-whtsapp picture">
                                    <img src={chatWindowImage} alt="Uploaded Preview" />
                                </button>
                            </em>
                            <input 
                                type="file" 
                                accept="image/*" 
                                onChange={handleChatWindowImageChange} 
                            />
                        </div>
                        <p>Set your company name with “Virtual Assistant” as the display name, and upload your company logo as the profile picture.</p>
                    </div>

                    <div className="side-baar-box-header">
                        <div className="box-header-row">
                            <span>Send Chat History to Email</span>
                            <div className="form-group">
                                <input
                                    type="checkbox"
                                    id="is_send_chat_history_to_email"
                                    className="chkbx-toggle"
                                    checked={isEnableChatHistoryToEmail}
                                    onChange={handleEnableChatHistoryToEmailChange}
                                />
                                <label htmlFor="is_send_chat_history_to_email"></label>
                            </div>
                        </div>

                        {Number(chatTabData.is_send_chat_history_to_email) === 1 && (
                            <>
                                <div className="box-header-row">
                                   <input type="text" value={ownerEmail} onChange={handleOwnerEmailChange} placeholder="Owner Email" />
                                </div>
                            </>
                        )}
                        <p>Automatically send a copy of the chat conversation to the widget owner’s email after the interaction ends.</p>
                    </div>

                    <div className="customize-elements-list">
                        <ul>
                            <li>
                                <button onClick={() => setActiveSettingElementsTab("language")}>Language <i className="fa fa-angle-right" aria-hidden="true"></i></button>
                            </li>
                            <li>
                                <button onClick={() => setActiveSettingElementsTab("time_zone")}>Time Zone <i className="fa fa-angle-right" aria-hidden="true"></i></button>
                            </li>
                            <li>
                                <button onClick={() => setActiveSettingElementsTab("custom_css")}>Custom CSS <i className="fa fa-angle-right" aria-hidden="true"></i></button>
                            </li>
                            <li>
                                <button onClick={() => setActiveSettingElementsTab("custom_js")}>Custom JS <i className="fa fa-angle-right" aria-hidden="true"></i></button>
                            </li>
                        </ul>
                    </div>
                </>
            )}

            {activeSettingElementsTab === "language" && (
                <>
                    <div className="inner-box-layout">
                        <span><button onClick={() => setActiveSettingElementsTab("main")}><i className="fa fa-angle-left" aria-hidden="true"></i>Back</button> Language</span>
                        <div className="css-text height-text">
                            <span>Language</span>
                            <em>English</em>
                        </div>
                    </div>
                </>
            )}

            {activeSettingElementsTab === "time_zone" && (
                <>
                    <div className="inner-box-layout">
                        <span><button onClick={() => setActiveSettingElementsTab("main")}><i className="fa fa-angle-left" aria-hidden="true"></i>Back</button> Time Zone</span>
                        <div className="css-text height-text">
                            <span>Time Zone</span>
                            <em>Default</em>
                        </div>
                    </div>
                </>
            )}

            {activeSettingElementsTab === "custom_css" && (
                <>
                    <div className="inner-box-layout">
                        <span><button onClick={() => setActiveSettingElementsTab("main")}><i className="fa fa-angle-left" aria-hidden="true"></i>Back</button> Custom CSS</span>
                        <div className="css-text height-text">
                            <CssCodeEditor code={styleTabCustomCss} setCode={setStyleTabCustomCss} onChangeComplete={handleCustomcssCodeChange}/>
                        </div>
                    </div>
                </>
            )}

            {activeSettingElementsTab === "custom_js" && (
                <>
                    <div className="inner-box-layout">
                        <span><button onClick={() => setActiveSettingElementsTab("main")}><i className="fa fa-angle-left" aria-hidden="true"></i>Back</button> Custom Js</span>
                        <div className="css-text height-text">
                            <JsCodeEditor code={jsTabCustomJs} setCode={setJsTabCustomJs} onChangeComplete={handleCustomJsCodeChange}/>
                            <div className="save-css-js"><button className="save-css-js" onClick={handleValidateClick}>Validate</button></div>
                        </div>
                    </div>
                </>
            )}
        </div>
    );
};

export default GeneralTab;